module.exports = __webpack_public_path__ + "portal-static/img/step.38cff03b.png";